import Platform from "../../../libs/utility/Platform";
import { Theme } from "../constants";

export default {
    stepper:{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent:"space-between",
        height: "100%",
    },
     stepContainer:{
        width: "100%",
        display: "flex",
        transition: "all .3s ease-in",
        gap: "10px",
    },
    step:{
        position: "relative",
        fontSize: "14px",
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%",
        textAlign: "center",
        transition: "all .3s ease-in",
    },
    stepTitle:{
        color: Theme.DISABLED_TEXT,
        display: "flex",
        height: "100%",
        paddingBottom: "5px",
    },
    stepTitleActive:{
        color: Theme.TEXT_PRIMARY_BLACK,
        fontWeight: 700,
    },
    stepTitleCompleted:{
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    stepLine:{
        display: "block",
        width: "100%",
        height: "4px",
        background: "#D4D6D7",
        zIndex: 1,
        position: "absolute",
        bottom: 0,
    },
    stepLineActive:{
        background: Theme.PRIMARY,
    },
    stepLineCompleted: {
        background: Theme.SECONDARY,
    },
    topRowStepperBtns:{
        display: "flex",
        margin: "10px 0px",
        justifyContent: "flex-end",
    },
    stepperBodyContainer: {
        display: "flex",
        height: "100%",
        overflowY: "auto",
    },
    stepperBodyContent: {
        position: "relative",
        width: "100%",
        minHeight: "55vh",
        overflowY: "auto",
    },
    bodyMain: {
        flex: "1 1 auto",
    },
    stepperButtonsContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    stepperFooter:{
        display: "flex",
        flexDirection: "column",
    },
    footerContainer:{
        display: "flex",
        flexDirection: Platform.isMobileView() ? "column" : "row",
        justifyContent: Platform.isMobileView() ? "none" : "space-between",
        alignItems: Platform.isMobileView() ? "end" : "unset",
        marginTop: "-40px",
        zIndex: 2,
    },
    footerTextContainer:{
        marginLeft: "50px",
    },
    footerText:{
        fontWeight:"400",
        fontSize: "14px",
        lineHeight: "23px",
    },
    stepperButtons: {
        padding: "4px 16px",
        fontSize: "14px",
    },
    discardButton: {
        fontSize: "16px",
    },
    footerImage: {
        width: "100%",
    },
    footerBodyContainer: {
        display: "flex",
    },
    footerBodyContent: {
        position: "relative",
        flexDirection: "column",
    },
    footerTextContainer: {
        position: "absolute",
        paddingTop: "10px",
        left: "65px"
    },
    progressbarContainer: {
        position: "absolute",
        right: "0px",
        top: "18px",
    },
    switchContainer: {
        display: "flex",
        alignItems: "center",
    },
    switchSpan: {
        marginRight: "8px",
        display: "flex",
    },
    switchLabelCustomStyle: {
        width: "28px",
        height: "14px",
    },
    switchButtonCustomStyle: {
        top: "1px",
        width: "10px",
        height: "10px",
    },
}